import React, { Component } from "react";
import client from "@culturehq/client";
import { Button, classnames, Icon, ModalDialog } from "@culturehq/components";

import { Trans } from "app/utils";

import BadgeIcon from "components/display/BadgeIcon";
import SurveyTake from "components/survey/SurveyTake";
import { Time } from "components/common/Time";
import ChqModalDialog from "./common/ChqModalDialog";

const ConfirmButton = React.memo(({ attended, children, onClick, status, typeClass }) => {
  const className = classnames("button", typeClass, attended === status ? "active" : "inactive");

  return (
    <Button className={className} onClick={() => onClick(status)}>
      <Icon icon="checkmark" /> {children}
    </Button>
  );
});

const ConfirmAttendance = ({ event, attended, onAttendanceSet }) => {
  const { name, startsAt } = event;

  return (
    <div className="ConfirmEventAttendance clearfix">
      <h2 className="did-you-attend">
        <Trans>Did you attend {name}?</Trans>
      </h2>
      <p className="did-you-attend-date">
        <Trans>On <Time time={startsAt} format="%A, %B %e, %Y" /></Trans>
      </p>
      <ConfirmButton attended={attended} onClick={onAttendanceSet} status typeClass="primary">
        <Trans>Yes</Trans>
      </ConfirmButton>
      <ConfirmButton attended={attended} onClick={onAttendanceSet} status={false} typeClass="secondary">
        <Trans>No</Trans>
      </ConfirmButton>
    </div>
  );
};

class EventSurveyPrompt extends Component {
  state = { attended: null, events: [] };

  async componentDidMount() {
    this.componentIsMounted = true;

    const { events } = await client.listProfileEventSurveys();

    if (this.componentIsMounted) {
      this.setState({ events });
    }
  }

  componentWillUnmount() {
    this.componentIsMounted = false;
  }

  handleAttendanceSet = async attended => {
    const { events: [{ id: eventId, survey }] } = this.state;

    await client[attended ? "confirmEventAttendance" : "denyEventAttendance"]({ eventId });

    if (this.componentIsMounted) {
      if (attended && survey) {
        this.setState({ attended });
      } else {
        this.handleSurveyComplete();
      }
    }
  };

  handleSurveyComplete = () => {
    this.setState(({ events }) => ({
      attended: null,
      events: events.slice(1)
    }));
  };

  render() {
    const { attended, events } = this.state;

    if (events.length < 1) {
      return null;
    }

    const event = events[0];
    const { survey } = event;

    return (
      <ChqModalDialog entrance="zoomIn" className="TakeSurveyModal" ariaLabelledBy="survey-title" ariaDescribedby="survey-title">
        <ModalDialog.Heading>
          <h2 id="survey-title"><Trans>Did you attend?</Trans></h2>
          {events.length > 1 && (
            <Trans> ({events.length} remaining)</Trans>
          )}
        </ModalDialog.Heading>
        <ModalDialog.Body>
          <BadgeIcon badge="event_survey" points={survey && survey.points} size="medium" />
          <ConfirmAttendance
            event={event}
            attended={attended}
            onAttendanceSet={this.handleAttendanceSet}
          />
          {attended && (
            <SurveyTake
              survey={survey}
              event={event}
              onSurveyComplete={this.handleSurveyComplete}
            />
          )}
        </ModalDialog.Body>
      </ChqModalDialog>
    );
  }
}

export default EventSurveyPrompt;
